module.exports = __webpack_public_path__ + "static/img/qr_code_2.2655a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr_code_2.jpg
// module id = YY9I
// module chunks = 20